import { db } from "config/firebase";
import { createHash } from "utils/helperFunctions";
import { doc, setDoc, updateDoc, deleteDoc } from "firebase/firestore";

const setRequest = async (data: any): Promise<void> => {
  await setDoc(doc(db, "requests", data.id), data);
};

const deleteRequest = async (reqId: string): Promise<void> => {
  await deleteDoc(doc(db, "requests", reqId));
};

const sendJoinGameRequest = async (user: any, gameData: any): Promise<void> => {
  const id = createHash(user.uid + gameData.id);
  const requestData = {
    id,
    gameId: gameData.id,
    senderId: user.uid,
    receiverId: gameData.hostId,
    senderName: user.displayName,
    gameName: gameData.gameName,
    timeStamp: Date.now(),
    status: "pending",
  };

  await setDoc(doc(db, "requests", id), requestData);
};

const acceptRequest = async (reqId: string): Promise<void> => {
  try {
    await updateDoc(doc(db, "requests", reqId), {
      status: "waitlist",
    });
  } catch (err) {
    console.warn(err);
  }
};

// Probably won't be used
const _declineRequest = async (reqId: string): Promise<void> => {
  await updateDoc(doc(db, "requests", reqId), {
    status: "declined",
  });
};

const pendingConfirmReq = async (
  reqId: string,
  expTime: number,
): Promise<void> => {
  await updateDoc(doc(db, "requests", reqId), {
    status: "confirmationPending",
    timeStamp: expTime,
  });
};

const hostConfirmReq = async (reqId: string): Promise<void> => {
  await updateDoc(doc(db, "requests", reqId), {
    status: "hostConfirmed",
    timeStamp: Date.now(),
  });
};

const playerConfirmReq = async (reqId: string): Promise<void> => {
  await updateDoc(doc(db, "requests", reqId), {
    status: "playerConfirmed",
    timeStamp: Date.now(),
  });
};

export default {
  setRequest,
  acceptRequest,
  deleteRequest,
  sendJoinGameRequest,
  pendingConfirmReq,
  hostConfirmReq,
  playerConfirmReq,
};
